import { Button, Icon } from '@salesforce/design-system-react';
import { Link, useNavigate } from 'react-router';

export const NoMatchPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="slds-align_absolute-center slds-p-around_large">
      <div className="slds-text-longform slds-text-align_center" style={{ maxWidth: 600, width: '100%' }}>
        <Icon category="utility" colorVariant="error" name="error" size="large" />
        <h1 className="slds-text-heading_large slds-m-top_medium">404 - Page Not Found</h1>
        <p className="slds-text-color_weak slds-text-heading_small">
          Sorry, the page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Button
          className="slds-m-top_medium"
          iconCategory="utility"
          iconName="home"
          iconPosition="left"
          label="Go to Home Page"
          onClick={() => {
            void navigate('/');
          }}
          variant="brand"
        />
        <p className="slds-text-color_weak slds-text-body_small slds-m-top_medium">
          If you believe this is an error, please{' '}
          <Link className="slds-text-link" to="/about">
            contact support
          </Link>
          .
        </p>
      </div>
    </div>
  );
};
